export default (client) => ({
  setStatus: (id, status) =>
    client(`/admin/lead/${id}/status/${status}`, {
      method: "PUT",
    }),
});
